import { odata } from '@bingads-webui/http-util';

const emailInfo = {
  UET: {
    EmailNotificationId: 388,
    EmailTemplateName: 'UetTagInstructionsEmail',
  },
  Event: {
    EmailNotificationId: 389,
    EmailTemplateName: 'UetTagAndEventTagInstructionsEmail',
  },
  UetTagInstructionsEmailV2: {
    EmailNotificationId: 589,
    EmailTemplateName: 'UetTagInstructionsEmailV2',
  },
  UetTagAndEventTagInstructionsEmailV2: {
    EmailNotificationId: 590,
    EmailTemplateName: 'UetTagAndEventTagInstructionsEmailV2',
  },
};

export const postEmail = (cid, aid, token, emailType, emailAddresses, emailContent) => {
  const { EmailNotificationId, EmailTemplateName } = emailInfo[emailType];

  const data = {
    EmailContent: Object.entries(emailContent).map(([k, v]) => ({ Key: k, Value: v })),
    EmailAddresses: emailAddresses,
    EmailTemplateName,
    EmailNotificationId,
    ToAdvertiser: true,
  };
  const url = aid ? `${window.location.origin}/ODataApi/Advertiser/V2/Customers(${cid})/Accounts(${aid})/SendEmail` :
    `${window.location.origin}/ODataApi/Advertiser/V2/Customers(${cid})/Accounts/SendEmail`;
  try {
    return odata.post({
      url,
      data,
      headers: {
        Authorization: `CCMTSmallToken ${token}`,
      },
    }).then((res) => {
      if (res && res.value) {
        return res;
      }
      return Promise.reject(res);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
